import React from 'react';
import folderIcon from '../../assets/img/folder.svg';
import panoramaMonoIcon from '../../assets/img/panoramaMono.svg';
import panoramaStereoIcon from '../../assets/img/panoramaStereo.svg';
import webStandaloneIcon from '../../assets/img/webStandalone.svg';
import galleryIcon from '../../assets/img/gallery.svg';
import { ContentDisplayName } from '../services/UploadManagementServiceTypes';

type SVG = string;

export interface ContentIconProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  displayName: ContentDisplayName;
  thumbnail?: string;
  iconSize?: number;
}

const defaultIconSize = 32;

const getIcon = (displayName: ContentDisplayName): SVG => {
  if (displayName === 'Folder') {
    return folderIcon;
  }
  if (displayName === 'Panorama Mono') {
    return panoramaMonoIcon;
  }
  if (displayName === 'Panorama Stereo') {
    return panoramaStereoIcon;
  }
  if (displayName === 'Web Standalone') {
    return webStandaloneIcon;
  }
  if (displayName === 'Panorama Gallery') {
    return galleryIcon;
  }
  return folderIcon;
};

export const ContentIcon: React.FC<ContentIconProps> = ({
  displayName,
  thumbnail,
  iconSize = defaultIconSize,
  ...rest
}) => (
  <img
    {...rest}
    src={thumbnail || getIcon(displayName)}
    style={{ objectFit: 'cover' }}
    alt={displayName}
    height={iconSize}
    width={iconSize}
  />
);
